import AccountAdminService from '@/api/admin/accountAdmin.service'

export default {
  state: {
    table: {
      pageLength: 10,
      rows: [],
      totalRecords: 0,
      searchTerm: '',
    },
    rowToDelete: {},
    userRoles: {},
    userModel: {},
    usersModel: {},
  },
  getters: {
    allUsers: state => state.table,
    userRoles: state => state.userRoles,
    rowToDelete: state => state.rowToDelete,
    getUserModel: state => state.userModel,
    getUsersModel: state => state.usersModel,
  },
  actions: {
    async getUsers({ commit }) {
      const users = await AccountAdminService.getUsers()
      commit('SET_USERS', users)
      commit('SET_TOTALRECORDS', users.totalRecords)
      commit('SET_USER_ROLES', users.platformRoles)
      commit('SET_USERS_MODEL', users)
    },
    async getFilteredUsers({ commit }, wrapper) {
      const users = await AccountAdminService.getFilteredUsers(wrapper)
      commit('SET_USERS', users)
      commit('SET_TOTALRECORDS', users.totalRecords)
      commit('SET_USER_ROLES', users.platformRoles)
      commit('SET_USERS_MODEL', users)
    },
  },
  mutations: {
    SET_USERS(state, users) {
      state.table.rows = users.platformUsers
    },
    SET_TOTALRECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
    SET_ROW_TO_DELETE(state, row) {
      state.rowToDelete = row
    },
    SET_USER_MODEL(state, userModel) {
      state.userModel = userModel
    },
    SET_USERS_MODEL(state, usersModel) {
      state.usersModel = usersModel
    },
    SET_USER_ROLES(state, userRoles) {
      state.userRoles = userRoles
    },
  },
}
